import React from "react";
import { Text } from "@fluentui/react-components";
import ResultCard from "./ResultCard";

const SelectedList = ({ items, onUnselect, className }) => {
  if (items.length === 0) return null;

  return (
    <div className={className}>
      <Text size={300} weight="regular" block>
        Selected results
      </Text>
      {items.map((item) => (
        <ResultCard
          key={`${item.uid}-${item.entityId}`}
          item={item}
          checked={true}
          onChange={() => onUnselect(item)}
        />
      ))}
    </div>
  );
};

export default SelectedList;
